import styled from "styled-components";
import { color, link } from "src/styles/variables";
import {
  headingStyles,
  h1Styles,
  h2Styles,
  h3Styles,
} from "src/react/typography/";

export const ContentSection = styled.section`
  & h1 {
    ${headingStyles};
    ${h1Styles};
  }

  & h2 {
    ${headingStyles};
    ${h2Styles};
  }

  & h3 {
    ${headingStyles};
    ${h3Styles};
  }

  & p,
  & ul,
  & ol {
    margin-bottom: 10px;
  }

  & a {
    ${link};
  }

  & li {
    line-height: 1.7;
    margin-left: 1em;
    position: relative;
  }

  & ul li:before {
    content: "- ";
    left: -0.9em;
    position: absolute;
  }

  & table {
    border-collapse: collapse;
    margin-bottom: 16px;
  }

  & table thead {
    color: ${color.darkGrey};
    font-size: 16px;
    font-weight: 600;
  }

  & table tr {
    border-bottom: 1px solid ${color.midGrey};
  }

  & table td {
    padding: 0.5em;
  }

  @media screen and (max-width: 800px) {
    & table {
      border: 0;
    }

    & table thead {
      display: none;
    }

    & table tr {
      border-bottom: 2px solid ${color.shipGrey};
      border-top: 2px solid ${color.shipGrey};
      display: block;
      margin-bottom: 10px;
      margin-top: 10px;
    }

    & table td {
      border-bottom: 1px dotted ${color.midGrey};
      display: block;
      font-size: 13px;
      text-align: right;
    }

    & table td:last-child {
      border-bottom: 0;
    }

    & table td:before {
      content: attr(data-label);
      float: left;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
`;
